/* tslint:disable */
/* eslint-disable */
/* @relayHash 90650a1be1f16631b42341e78fc698aa */

import { ConcreteRequest } from "relay-runtime";
export type EditNewslettersInput = {
    userServiceId: string;
    emailToken?: string | null;
    promotional?: boolean | null;
    favoriteSearches?: boolean | null;
    favoriteDealers?: boolean | null;
    trade?: boolean | null;
    smsOptin?: boolean | null;
    orderFeedbackMailOptin?: boolean | null;
    clientMutationId?: string | null;
};
export type subscribeUserMutationVariables = {
    input: EditNewslettersInput;
};
export type subscribeUserMutationResponse = {
    readonly editNewsletters: {
        readonly clientMutationId: string | null;
    } | null;
};
export type subscribeUserMutation = {
    readonly response: subscribeUserMutationResponse;
    readonly variables: subscribeUserMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "EditNewslettersInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "editNewsletters",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EditNewslettersPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "subscribeUserMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "subscribeUserMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "subscribeUserMutation",
    "id": "ferrum/270.0.0-2020-06-18T22:37:41.615Z/subscribeUserMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'c9543e77c781df16904396e3a1064187';
export default node;
